/**
 * Returns the offset of a mouse event relative to the specified target element.
 *
 * https://stackoverflow.com/a/35364901
 *
 * @param event
 * @param targetElement element to which the event listener is attached (typically `event.currentTarget`)
 */
export function getEventTargetMouseOffset(
  event: MouseEvent,
  targetElement: HTMLElement,
): { eventOffsetX: number; eventOffsetY: number } {
  // instead of `event.offsetX` and `event.offsetY` (which are relative to parent element), use `getBoundingClientRect`
  const targetRectangle = targetElement.getBoundingClientRect()

  const eventOffsetX = event.clientX - targetRectangle.left
  const eventOffsetY = event.clientY - targetRectangle.top

  return {
    eventOffsetX,
    eventOffsetY,
  }
}
